/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const submitContactForm = /* GraphQL */ `
  mutation SubmitContactForm($input: ContactFormInput!) {
    submitContactForm(input: $input) {
      name
      phone
      email
      message
    }
  }
`;
export const createSubscriber = /* GraphQL */ `
  mutation CreateSubscriber($email: String!) {
    createSubscriber(email: $email) {
      id
      email
      createdAt
      updatedAt
    }
  }
`;
export const updateSubscriber = /* GraphQL */ `
  mutation UpdateSubscriber($id: ID!, $email: String!) {
    updateSubscriber(id: $id, email: $email) {
      id
      email
      createdAt
      updatedAt
    }
  }
`;
export const deleteSubscriber = /* GraphQL */ `
  mutation DeleteSubscriber($id: ID!) {
    deleteSubscriber(id: $id) {
      id
      email
      createdAt
      updatedAt
    }
  }
`;
export const createSubscribersStaging = /* GraphQL */ `
  mutation CreateSubscribersStaging($input: CreateSubscribersStagingInput!) {
    createSubscribersStaging(input: $input) {
      email
    }
  }
`;
export const updateSubscribersStaging = /* GraphQL */ `
  mutation UpdateSubscribersStaging($input: UpdateSubscribersStagingInput!) {
    updateSubscribersStaging(input: $input) {
      email
    }
  }
`;
export const deleteSubscribersStaging = /* GraphQL */ `
  mutation DeleteSubscribersStaging($input: DeleteSubscribersStagingInput!) {
    deleteSubscribersStaging(input: $input) {
      email
    }
  }
`;
